export const company = {
  name: "G. Copchilet",
  tagline: "Peinture · Vitrerie · Façades",
  manager: "M. Ghenadii Copchilet",
  address: "48 avenue Clemenceau, bâtiment G",
  city: "77100 Meaux",
  siren: "944 099 191",
  siret: "944 099 191 00016",
  naf: "4334Z — Travaux de peinture et vitrerie",
  created: "2025",
  status: "Artisan indépendant",
};

export const navigation = [
  { label: "Accueil", to: "/" },
  { label: "Prestations", to: "/prestations" },
  { label: "L'artisan", to: "/artisan" },
  { label: "Réalisations", to: "/realisations" },
  { label: "Contact", to: "/contact" },
];

export const zones = [
  "Meaux",
  "Villenoy",
  "Chauconin-Neufmontiers",
  "Crégy-lès-Meaux",
  "Nanteuil-lès-Meaux",
  "Trilport",
  "Mareuil-lès-Meaux",
  "Penchard",
  "Claye-Souilly",
  "Lagny-sur-Marne",
];
